import { inject, observer } from 'mobx-react';
import React, { Component, Fragment } from 'react';
import { Row, Col, Card, Button, Divider, Collapse, Empty, Form, Select, InputNumber } from 'antd';
import { TriggerForm } from './TriggerForm';
import { TriggerCard } from './TriggerCard';
import { ActionsMenu } from './ActionsMenu';
import { Actions } from './actions';
import { Status } from './Status';
const Panel = Collapse.Panel;
const Option = Select.Option;
@inject('store')
@observer
export class TriggerView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            openNew: false,
            openActions: false
        };
    }

    componentDidMount() {
        this.props.store.botStore.triggerStore.getLogs();
    }

    render() {
        const exchangeConfig = this.props.store.exchangeConfig[
            this.props.store.botStore.currentConfiguration.exchange
        ];

        return (
            <Row gutter={24}>
                <Col md={16}>
                    <Card title="Default State" style={{ marginBottom: 15 }} bordered={false}>
                        <p>
                            The state the bot is in when no triggers are firing or the cooldown
                            timer has expired.
                        </p>

                        <Row gutter={24}>
                            <Col md={12}>
                                <Form.Item
                                    label={'Stable Coin'}
                                    extra={'Coin used when panic selling to stable'}
                                >
                                    <Select
                                        style={{ width: '100%' }}
                                        onChange={value =>
                                            this.props.store.botStore.triggerStore.updateDefaultValue(
                                                'stable_coin',
                                                value
                                            )
                                        }
                                        defaultValue={'USDT'}
                                        value={
                                            this.props.store.botStore.currentConfiguration
                                                .default_trigger.stable_coin
                                        }
                                    >
                                        {exchangeConfig.tether_coins.map(base => (
                                            <Option value={base}>{base}</Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col md={12}>
                                <Form.Item
                                    label={'Amount the bot will rebuy '}
                                    extra={'The bot will calculate this after a panic sell'}
                                >
                                    <InputNumber
                                        min={0}
                                        defaultValue={0}
                                        onChange={value =>
                                            this.props.store.botStore.triggerStore.updateDefaultValue(
                                                'rebuy_amount',
                                                value
                                            )
                                        }
                                        value={
                                            this.props.store.botStore.currentConfiguration
                                                .default_trigger.rebuy_amount
                                        }
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Divider orientation={'left'}>Actions</Divider>

                        {this.renderCollapse()}
                        <ActionsMenu
                            onSelect={item => {
                                this.props.store.botStore.triggerStore.addDefaultAction(
                                    this.props.id,
                                    item
                                );
                            }}
                            visible={this.state.openActions}
                            onCancel={() => this.setState({ openActions: false })}
                        />
                    </Card>

                    <Card
                        title="Rules"
                        bordered={false}
                        extra={
                            <Button
                                type={'primary'}
                                onClick={() => this.setState({ openNew: true })}
                            >
                                Create Rule
                            </Button>
                        }
                    >
                        <p>Rules are executed one at a time and in order shown below</p>
                        {(this.props.store.botStore.currentConfiguration.triggers || []).map(
                            (trigger, i) => {
                                return (
                                    <TriggerCard
                                        key={i}
                                        id={i}
                                        max={
                                            (
                                                this.props.store.botStore.currentConfiguration
                                                    .triggers || []
                                            ).length
                                        }
                                        trigger={trigger}
                                    />
                                );
                            }
                        )}
                    </Card>

                    <TriggerForm
                        visible={this.state.openNew}
                        onCancel={() => this.setState({ openNew: false })}
                    />
                </Col>

                <Col md={8}>
                    <Status />
                </Col>
            </Row>
        );
    }

    renderCollapse() {
        if (this.props.store.botStore.currentConfiguration.default_trigger.actions.length) {
            return (
                <Fragment>
                    <Collapse>
                        {this.props.store.botStore.currentConfiguration.default_trigger.actions.map(
                            (action, i) => {
                                const inputs = Actions[action.id].inputs;

                                return (
                                    <Panel header={action.name} key={i}>
                                        <Row gutter={24}>
                                            {inputs.map((input, x) => {
                                                let options = [];

                                                if (input.options) {
                                                    const opts =
                                                        typeof input.options === 'function'
                                                            ? input.options()
                                                            : input.options;
                                                    options = opts.map(o => (
                                                        <Option key={o.id} id={o.id}>
                                                            {o.name}
                                                        </Option>
                                                    ));
                                                }

                                                return (
                                                    <Col md={12} key={x}>
                                                        <Form.Item label={input.label}>
                                                            <input.component
                                                                style={{ width: '100%' }}
                                                                value={action[input.name]}
                                                                defaultValue={input.default}
                                                                onChange={e => {
                                                                    const value =
                                                                        (e.target &&
                                                                            e.target.value) ||
                                                                        e;
                                                                    this.props.store.botStore.triggerStore.updateDefaultAction(
                                                                        i,
                                                                        input.name,
                                                                        value
                                                                    );
                                                                }}
                                                            >
                                                                {options}
                                                            </input.component>
                                                        </Form.Item>
                                                    </Col>
                                                );
                                            })}
                                        </Row>
                                        <div style={{ textAlign: 'right', padding: 10 }}>
                                            <Button
                                                onClick={() =>
                                                    this.props.store.botStore.triggerStore.removeDefaultAction(
                                                        i
                                                    )
                                                }
                                                type={'danger'}
                                            >
                                                Remove Action
                                            </Button>
                                        </div>
                                    </Panel>
                                );
                            }
                        )}
                    </Collapse>
                    <Button
                        type={'primary'}
                        block
                        style={{ marginTop: 10 }}
                        onClick={() => this.setState({ openActions: true })}
                    >
                        Add Action
                    </Button>
                </Fragment>
            );
        }

        return (
            <Empty>
                <Button
                    type={'primary'}
                    style={{ marginTop: 10 }}
                    onClick={() => this.setState({ openActions: true })}
                >
                    Add Action
                </Button>
            </Empty>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Bot/TriggerView/index.js